import React from 'react';
import { CopyText } from '@therms/atalaya';
import { useParams } from 'react-router-dom';
import './ScopeProcedure.css';

export const ScopeProcedure = (props) => {
  const params = useParams();

  return (
    <div className="scope-procedure">
      <strong>{props.params.scope}</strong> {props.params.procedure}
      <div className="mt-1">
        <CopyText
          value={`{ scope: "${params.scope}", procedure: "${params.procedure}", version: "${params.version}" }`}
        >
          <pre className="text-sm">
            {'{'} scope: "{params.scope}", procedure: "{params.procedure}",
            version: "{params.version}" {'}'}
          </pre>
        </CopyText>
      </div>
    </div>
  );
};
